export enum ClinicToolbarItemType {
  dateTime = 'date-time',
  image = 'image',
  imageText = 'image-text',
  text = 'text'
}

